import { AbilityProvider as CaslAbilityProvider, useAbility as useCaslAbility } from "@casl/react";
import { type ReactNode, useMemo } from "react";
import { useProfile } from "../hooks/use-profile";
import { type AppAbility, defineAbilityFor } from "./ability";

/**
 * Rebuilds the caller's ability whenever their profile changes, e.g. after a
 * sign-in that picked up new Entra groups. Until the profile loads, nothing is
 * allowed.
 */
export function AbilityProvider({ children }: { children: ReactNode }) {
  const { profile } = useProfile();
  const ability = useMemo(() => defineAbilityFor(profile), [profile]);
  return <CaslAbilityProvider value={ability}>{children}</CaslAbilityProvider>;
}

/** `const ability = useAbility(); ability.can("update", asDocument(doc))` */
export function useAbility(): AppAbility {
  return useCaslAbility<AppAbility>();
}
